export { default } from './WorkplaceChallenges';



// WEBPACK FOOTER //
// ./src/components/templates/WorkplaceChallenges/index.js